<!--
 * @Description: 业务区域
 * @Author: yangsibo
 * @Date: 2022-05-12 08:59:49
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-07-11 15:27:05
 * @FilePath: \YunYin_admin\src\views\Setting\DefaultRole\index.vue
-->
<template>
  <el-main class="business-area">
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <el-tabs v-model="activeName">
        <el-tab-pane label="村集体系统" name="4">
          <DefaultRoleList
            v-if="activeName == '4'"
            :systemType="Number(activeName)"
          ></DefaultRoleList>
        </el-tab-pane>
        <el-tab-pane label="合作社系统" name="3">
          <DefaultRoleList
            v-if="activeName == '3'"
            :systemType="Number(activeName)"
          ></DefaultRoleList>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-main>
</template>

<script>
import DefaultRoleList from "./list";
export default {
  name: "DefaultRole",
  components: { DefaultRoleList },
  data() {
    return {
      activeName: "4",
    };
  },
  methods: {},
  created() {},
};
</script>
<style lang="scss" scoped>
.main {
  ::v-deep .el-tabs__nav-wrap {
    .el-tabs__nav {
      .el-tabs__item {
        font-size: 16px;
        &.is-active {
          font-weight: bold;
          color: #048489;
        }
      }
    }
    &::after {
      height: 0;
    }
  }
}
</style>
